@use "../../../assets/styles/abstracts/variables" as v;
@use "../../../assets/styles/abstracts/mixins/typography" as t;

.input {
  height: 48px;
  width: 100%;
  padding: 13px 16px;
  border-radius: 6px;
  border: 1px solid v.$palette-signal-live;
  background: v.$palette-signal-bg;
  color: v.$palette-white;
  @include t.text(14px, 22px, "normal");
  transition: border-color 0.2s ease;

  &::placeholder {
    color: v.$palette-signal-structure;
  }

  &:hover:not(:disabled):not(.inputError) {
    border-color: v.$palette-green-500;
  }

  &:focus-visible {
    outline: none;
    border-color: v.$palette-green-500;
  }
}

.input[type="number"] {
  -moz-appearance: textfield;
  appearance: textfield;

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
}

.inputDisabled {
  color: v.$palette-gray-700;
}

.inputError {
  border-color: v.$error-color;

  &:hover:not(:disabled) {
    border-color: v.$error-color;
  }

  &:focus-visible {
    border-color: v.$error-color;
  }
}

.inputTextarea {
  height: 80px;
  resize: none;
}

.inputEmbedded {
  height: 48px;
  min-height: 0;
  width: 100%;
  padding: 0;
  border: none;
  border-radius: 6px;
  background: transparent;
  box-shadow: none;
}

.inputEmbedded:hover,
.inputEmbedded:focus,
.inputEmbedded:focus-visible {
  border: none;
  box-shadow: none;
}

.label {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
}

.labelText {
  color: v.$palette-gray-500;
  @include t.text(13px, 20px, "normal");
}

.labelTextDisabled {
  opacity: 0.5;
}

.renderIcon {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  pointer-events: none;
}

.inputRenderIcon {
  padding-right: 40px;
}

.errorMessage {
  color: v.$error-color;
  @include t.text(12px, 18px, "normal");
}
